import React, { } from 'react';
import { VisualizerView, VisualizerViewProps } from '../../molecules/VisualizerView';
import { MovableFrame } from 'components/views/atoms/MovableFrame';
import { useState } from 'react';
import { useCallback } from 'react';
import useKeyPressEvent from 'react-use/lib/useKeyPressEvent';

export type VisualizerWidgetProps = Omit<VisualizerViewProps, 'engine'> & {
    engine?: VisualizerViewProps['engine'];
    width?: number;
    height?: number;
    top?: number;
    left?: number;
};

export function VisualizerWidget(props: VisualizerWidgetProps) {
    const {
        engine,
        width = 200, height = 300,
        top = 10, left = 10,
    } = props;

    const [shrunk, setShrunk] = useState(true);
    const onShrink = useCallback((shrunk: boolean) => {
        setShrunk(!shrunk);
    }, []);

    const [visible, setVisible] = useState(false);
    useKeyPressEvent('Shift', () => setVisible(true), () => setVisible(false));

    return (
        <MovableFrame
            width={width} height={height} top={top} left={left}
            title='sensor visualization'
            shrinkable={true}
            shrunk={shrunk}
            onShrink={onShrink}
            resizable={true}
            visible={!shrunk || visible}
        >
            {engine && !shrunk ? <VisualizerView engine={engine} /> : <></>}
        </MovableFrame>
    );
}
